module.exports = __webpack_public_path__ + "img/pix-original.d7634e01.jpg";